export const FEEDBACK_NAVBAR_LINK_URL = 'FEEDBACK_NAVBAR_LINK_URL';
export const HEADER_RESPONSIBLE_RESPONSIBLE = 'HEADER_RESPONSIBLE_RESPONSIBLE';
export const MOBILE_RESPONSIBLE_GAMING_SUPPORT_TITLE = 'MOBILE_RESPONSIBLE_GAMING_SUPPORT_TITLE';

export const MOBILE_HELP_PAGE_SUBMENU_TERMS = 'MOBILE_HELP_PAGE_SUBMENU_TERMS';
export const MOBILE_TERMS_CONDITIONS_SUPPORT_TITLE = 'MOBILE_TERMS_CONDITIONS_SUPPORT_TITLE';

export const SIDE_MENU_PRIVACY_POLICY = 'SIDE_MENU_PRIVACY_POLICY';
export const MOBILE_PRIVACY_POLICY_SUPPORT_TITLE = 'MOBILE_PRIVACY_POLICY_SUPPORT_TITLE';

export const MOBILE_ABOUT_US_MAINTITLE = 'MOBILE_ABOUT_US_MAINTITLE';
export const MOBILE_ABOUT_US_SUBTITLE = 'MOBILE_ABOUT_US_SUBTITLE';

export const BASE_MAIN_ROUTES_TEXT_KEYS = [
	FEEDBACK_NAVBAR_LINK_URL,
	HEADER_RESPONSIBLE_RESPONSIBLE,
	MOBILE_HELP_PAGE_SUBMENU_TERMS,
	MOBILE_TERMS_CONDITIONS_SUPPORT_TITLE,
	SIDE_MENU_PRIVACY_POLICY,
	MOBILE_PRIVACY_POLICY_SUPPORT_TITLE,
	MOBILE_ABOUT_US_MAINTITLE,
	MOBILE_ABOUT_US_SUBTITLE,
	MOBILE_RESPONSIBLE_GAMING_SUPPORT_TITLE
];
